<template>
  <div>
    <Head :title="`${team.name} - Locations`" />
    <div class="flex justify-start mb-8 max-w-3xl">
      <h1 class="text-3xl font-bold">
        <Link class="text-orange-400 hover:text-orange-600" href="/teams">Teams</Link>
        <span class="text-orange-400 font-medium">/</span>
        {{ team.name }}
      </h1>
    </div>
    <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="update">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <select-input v-model="form.location" :error="form.errors.location" class="pb-8 pr-6 w-full lg:w-full" label="Feature">
            <option :value="null">
              Select Location
            </option>
            <option
              v-for="location in locations"
              :key="location.id"
              :value="location.id"
            >
              {{ location.name }}
            </option>
          </select-input>
        </div>
        <div class="flex items-center px-8 py-4 bg-gray-50 border-t border-gray-100">
          <loading-button :loading="form.processing" class="btn-orange ml-auto" type="submit">Assign Locations</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  components: {
    Head,
    Link,
    LoadingButton,
    SelectInput,
  },
  layout: Layout,
  props: {
    team: Object,
    locations: Object,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        team: this.team.id,
        location: '',
      }),
    }
  },
  methods: {
    update() {
      this.form.post(`/team/${this.team.id}/assign-locations`)
    },
  },
}
</script>
